import React from 'react';
import classNames from 'classnames/bind';
import Icon from 'components/Icon/Icon';
import { SvgIcons } from 'common/consts/svgIcons';
import styles from './InputEmail.module.scss';

type Props = {
  label: string;
  name: string;
  value: string;
  placeholder?: string;
  hasError?: boolean;
  isValid?: boolean;
  error?: any;
  readOnly?: boolean;
  onChange: () => void;
  onFocusOut: (event:any) => void;
};

const cx = classNames.bind(styles);

const InputEmail = ({
  label,
  name,
  value,
  placeholder,
  isValid,
  hasError,
  error,
  readOnly,
  onChange,
  onFocusOut
}: Props) => {
  const wrapperStyle = cx({
    wrapper: true,
    hasError: error,
  });
  const inputStyle = cx({
    input: true,
    hasError: error,
  });
  return (
    <label className={wrapperStyle}>
      <div className={styles.label}>{label}</div>
      <div className={styles.inputWrapper}>
        <input
          type="text"
          name={name}
          placeholder={placeholder}
          className={inputStyle}
          aria-invalid="true"
          value={value || ""}
          readOnly={readOnly}
          onChange={onChange}
          onBlur = {(e)=>onFocusOut(e)}
        />
        {error && <Icon type={SvgIcons.ERROR} width={16} className={styles.stateIcon} />}
        {isValid && <Icon type={SvgIcons.SUCCESS} width={24} className={styles.stateIcon} />}
      </div>
      {error && <span className={styles.error}>{error.message}</span>}
    </label>
  );
};

export default InputEmail;
